import { render, staticRenderFns } from "./safeSelfCheckActivity.vue?vue&type=template&id=3228b2d4"
import script from "./safeSelfCheckActivity.vue?vue&type=script&lang=js"
export * from "./safeSelfCheckActivity.vue?vue&type=script&lang=js"
import style0 from "./safeSelfCheckActivity.vue?vue&type=style&index=0&id=3228b2d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports